import { FC } from "react";
import Container from "react-bootstrap/Container";
import Badge from "react-bootstrap/Badge";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { userRoute } from "app/route/Routes";
import { useUserQuery } from "app/api/graph/types";
import { useRouteParams } from "app/route/route";
import { userGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const UserScreen: FC = () => {
    const { userId } = useRouteParams(userRoute);
    const { data, loading, error } = useUserQuery({ variables: { userId: userGraphId(userId) } });
    const user = data?.user;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!user) {
        return <ErrorScreen title="Error" message="Not found." />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={userRoute} />
                <h1>{user.fullName}</h1>

                <div className="d-flex gap-2">
                    {user.emailVerified === true ? (
                        <Badge bg="success">Email verified</Badge>
                    ) : user.emailVerified === false ? (
                        <Badge bg="danger">Email not verified</Badge>
                    ) : null}

                    {user.disabled === true ? (
                        <Badge bg="danger">User disabled</Badge>
                    ) : user.disabled === false ? (
                        <Badge bg="success">User enabled</Badge>
                    ) : null}
                </div>
            </Container>
        </NavigationScreen>
    );
};
